import { create } from "zustand"

export const useCamTargetStore = create((set) => ({
    camTargetPosition: [-2.62, 1.78, -.28],
    setTargetPosition: (newPos) => set((state) => ({ camTargetPosition: newPos }))
}))
